import type {
  UseInvalidateOptions,
  UseValidateOptions,
} from "@/hooks/queries/validation";

import {
  useInvalidateModel,
  useValidateModel,
} from "@/hooks/queries/validation";

export const useValidateObservation = (
  observationId: number,
  options?: UseValidateOptions
) => {
  const { mutate, ...queryResult } = useValidateModel(
    "observations",
    observationId,
    options
  );

  const validate = () => {
    mutate(null);
  };

  return {
    ...queryResult,
    validate,
  };
};

export const useInvalidateObservation = (
  observationId: number,
  options?: UseInvalidateOptions
) => {
  const { mutate, ...queryResult } = useInvalidateModel(
    "observations",
    observationId,
    options
  );

  const invalidate = () => mutate(null);

  return {
    ...queryResult,
    invalidate,
  };
};
